var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoopArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 5.46007C14.2796 5.46007 14.4203 5.89991 14.2 6.18039C13.7203 6.74055 13.2398 7.28039 12.7601 7.84055C12.6203 8.0007 12.3203 8.0007 12.1601 7.84055C11.6804 7.28039 11.2 6.74055 10.7203 6.18039C10.4203 5.84055 10.8 5.36006 11.1406 5.46007H12.0203C11.5406 3.53975 10.0804 1.96007 8.09989 1.52027C7.72021 1.44058 7.33973 1.39995 6.96005 1.39995C5.03973 1.39995 3.26005 2.46011 2.32025 4.19995C2.06009 4.67963 1.34057 4.26011 1.59993 3.77963C2.87961 1.45923 5.56013 0.119433 8.17953 0.700033C10.5397 1.20003 12.3795 3.10003 12.8599 5.46023H13.8998L13.9 5.46007Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.42037 8.02013C0.0406899 8.02013 -0.0999501 7.58029 0.12037 7.29981C0.60005 6.73965 1.08053 6.19981 1.56021 5.63965C1.70005 5.47949 2.00005 5.47949 2.16021 5.63965C2.63989 6.19981 3.12037 6.73965 3.60005 7.29981C3.90005 7.63965 3.52036 8.12013 3.17973 8.02013H2.30005C2.77973 9.94045 4.23989 11.5201 6.22045 11.9599C6.60013 12.0396 6.98061 12.0802 7.36029 12.0802C9.28061 12.0802 11.0603 11.0201 12.0001 9.28024C12.2603 8.80056 12.9798 9.22008 12.7204 9.70056C11.44 12.0396 8.76021 13.3796 6.14001 12.7998C3.77981 12.2794 1.91961 10.3794 1.44001 8.02016L0.42037 8.02013Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopArrows);
export default __webpack_public_path__ + "static/media/loop-arrows.42e5c4e5.svg";
export { ForwardRef as ReactComponent };